import { DAEMON_URL } from "../config";
import { HttpError } from "./errors";

export type IssueStatus = "open" | "working" | "paused" | "done" | "error";

export type Issue = {
  id: number;
  project_id: string;
  title: string;
  body: string;
  source: "manual" | "notion";
  source_ref: string | null;
  source_url: string | null;
  status: IssueStatus;
  branch: string | null;
  conversation_id: number | null;
  // Cost/spend + creator are admin-only and omitted from the API for members.
  budget_cents?: number;
  spent_cents?: number;
  status_note: string | null;
  created_by?: string | null;
  created_at: number;
  updated_at: number;
};

async function req<T>(path: string, init: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${DAEMON_URL}${path}`, { ...init, credentials: "include" });
  } catch (e) {
    throw new Error(`network error: ${(e as Error).message}`);
  }
  const text = await res.text();
  let data: unknown;
  try { data = text ? JSON.parse(text) : {}; } catch { data = {}; }
  if (!res.ok) {
    const msg = (data as { error?: string })?.error ?? `http ${res.status}`;
    throw new HttpError(res.status, msg);
  }
  return data as T;
}

export async function listIssues(project: string): Promise<Issue[]> {
  const j = await req<{ issues: Issue[] }>(`/projects/${encodeURIComponent(project)}/issues`, {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  return j.issues;
}

export async function createIssue(
  project: string,
  args: { title: string; body?: string; budgetUsd?: number; autoStart?: boolean },
): Promise<Issue> {
  const j = await req<{ issue: Issue }>(`/projects/${encodeURIComponent(project)}/issues`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(args),
  });
  return j.issue;
}

export async function startIssue(project: string, id: number): Promise<void> {
  await req<{ ok: boolean }>(
    `/projects/${encodeURIComponent(project)}/issues/${id}/start`,
    { method: "POST", headers: { Accept: "application/json" } },
  );
}
